import { withStyles } from "@mui/styles";
import { Cookies } from "react-cookie";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "Theme";
import { rem } from "assets/js/common";

function Guide(theme) {
  let cookies = new Cookies();
  const { isLight } = useSelector(state => state.theme);
  // const palette = isLight === "true" ? lightTheme.palette : darkTheme.palette;
  let palette;
  console.log("isLight", cookies.get("isLight"));
  if (cookies.get("isLight")) {
    palette =
      cookies.get("isLight") === "true"
        ? lightTheme.palette
        : darkTheme.palette;
  } else {
    palette = darkTheme.palette;
  }

  const GuideCss = withStyles({
    "@global": {
      ".guide-wrap": {
        height: "100%",

        "& main": {
          // paddingBottom: rem(100),
        },
        "& .guide-h2": {
          fontSize: rem(32),
        },
        "& .guide-h3": {
          marginBottom: rem(20),
          color: "#8a949e",
          letterSpacing: "1px",

          // "&:not(:first-of-type)": {
          //     marginTop: rem(50),
          // }
        },
        "& .guide-h4": {
          marginBottom: rem(10),
          color: "#8a949e",
        },
        "& .guide-hr": {
          margin: "50px 0",
          borderStyle: "solid",
          borderColor: "#E9E9E9",
        },
      },
      ".guide-typeface": {
        "& .MuiGrid-item": {
          "& .item": {
            padding: rem(10),
            border: `1px solid ${palette.info.light}`,
            borderRadius: rem(10),
            "& .font": {
              fontSize: rem(50),
            },
            "& .info": {
              display: "flex",
              justifyContent: "space-between",
            },
          },
        },
      },
      ".guide-color": {
        "& .MuiGrid-item": {
          minWidth: rem(100),
          "& .item": {
            overflow: "hidden",
            border: `1px solid ${palette.info.light}`,
            borderRadius: rem(8),

            "& .MuiChip-root": {
              height: rem(80),
              width: "100%",
              borderRadius: 0,
              "& .MuiChip-label": {
                fontSize: rem(14),
              },
            },
            "& .value": {
              padding: rem(10),
              fontSize: rem(14),
              color: "#000",
              textAlign: "center",
            },
          },
        },
      },
      ".drawer-guide-right": {
        "& .MuiPaper-root": {
          width: "70vw",
        },
      },
      ".accordion-codemirror.MuiAccordion-root": {
        marginTop: rem(10),
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
        "& .MuiAccordionSummary-root": {
          display: "inline-flex",
          minHeight: "auto",
          padding: 0,
          "& .MuiAccordionSummary-content": {
            margin: `${rem(10)} 0`,
            lineHeight: 1,
          },
          "&.Mui-expanded": {
            minHeight: "auto",
          },
        },
        "& .MuiAccordionDetails-root": {
          padding: 0,
        },
        "&.Mui-expanded": {
          marginTop: rem(10),
          marginBottom: 0,
        },
      },
      ".CodeMirror-code": {
        fontSize: rem(12),
        letterSpacing: "0.5px",
      },
      ".CodeMirror-sizer": {
        minWidth: rem(500),
      },
      ["@media (max-width:768px)"]: {
        ".guide-wrap": {
          "& main": {
            // padding: rem(30),
          },
        },
        ".guide-typeface": {
          "& .MuiGrid-item": {
            flex: 1,
            flexBasis: "50%",
          },
        },
      },
    },
  })(() => null);

  return <GuideCss />;
}

export default Guide;
